import React, {Fragment} from 'react';
import type {TypographyVariant} from '@material-ui/core';
import {
    Box,
    Divider,
    Grid,
    Link,
    Typography,
    useTheme,
} from '@material-ui/core';
import {Utils} from 'commons';

function FontWeights() {
    return (
        <>
            <Box sx={{fontWeight: 'lighter', fontSize: 16, m: 1}}>
                {'Light'}
            </Box>
            <Box sx={{fontWeight: 300, fontSize: 16, m: 1}}>{'Regular'}</Box>
            <Box sx={{fontWeight: 500, fontSize: 16, m: 1}}>{'Medium'}</Box>
            <Box sx={{fontWeight: 'bold', fontSize: 16, m: 1}}>{'Bold'}</Box>
        </>
    );
}

function getProperties<Type, Key extends keyof Type>(
    obj: Type,
    keys: Array<Key>
) {
    return keys.map((value, key) => {
        return (
            <Box key={'sdf-' + key}>
                {`${value}: ${Utils.functions.getProperty(obj, value)}`}
            </Box>
        );
    });
}

function Typo() {
    const theme = useTheme();
    const typo = theme.typography;
    const props = [
        'fontFamily',
        'fontWeight',
        'fontSize',
        'lineHeight',
        'color',
    ];

    const item = (
        name: string,
        variant: TypographyVariant,
        link?: boolean,
        bold?: boolean
    ) => (
        <Box mt={2}>
            <Grid container>
                <Grid item xs={6}>
                    {link ? (
                        <Link
                            variant={variant}
                            color={'textPrimary'}
                            style={{
                                fontWeight: bold ? 'bold' : 'unset',
                                textTransform:
                                    variant === 'button' ? 'initial' : 'unset',
                            }}
                            underline={'always'}>
                            {name}
                        </Link>
                    ) : (
                        <Typography
                            variant={variant}
                            gutterBottom
                            style={{fontWeight: bold ? 'bold' : 'unset'}}>
                            {name}
                        </Typography>
                    )}
                    <Typography variant={'subtitle2'}>{variant}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Box sx={{m: 1, mt: 2}}>
                        <Typography
                            variant={'subtitle2'}
                            component='div'
                            gutterBottom>
                            {getProperties(typo[variant], props)}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            <Divider variant='middle' />
        </Box>
    );
    return (
        <Fragment>
            <Typography variant='subtitle1' gutterBottom>
                {'Weight'}
            </Typography>
            <Divider variant='middle' />
            <Typography component='div' gutterBottom>
                <FontWeights />
            </Typography>
            <Typography variant={'subtitle1'} gutterBottom>
                {'Headings'}
            </Typography>
            <Divider variant='middle' />
            <Box mt={2}>
                {item('Heading 1', 'h1')}
                {item('Heading 2', 'h2')}
                {item('Heading 3', 'h3')}
                {item('Heading 4', 'h4')}
            </Box>
            <Typography variant='subtitle1' gutterBottom>
                {'Commons'}
            </Typography>
            <Divider variant='middle' />
            <Box>
                {item('Body', 'body1')}
                {item('Body Bold', 'body1', false, true)}
                {item('Body Link', 'body1', true, false)}
                {item('Body Link Bold', 'body1', true, true)}
            </Box>
            <Divider variant='middle' />
            <Box>
                {item('Body Small', 'body2')}
                {item('Body Small Bold', 'body2', false, true)}
                {item('Body Small Link', 'body2', true, false)}
                {item('Body Small Link Bold', 'body2', true, true)}
            </Box>
            <Divider variant='middle' />
            <Box>
                {item('Text title', 'subtitle1')}
                {item('Button', 'button')}
                {item('Link Button', 'button', true)}
                {item('Caption', 'caption')}
            </Box>
        </Fragment>
    );
}

export default Typo;
